import { map } from 'rxjs';
import { memo } from '../util/index.js';
export function votesOf(instanceId, api) {
  return memo(instanceId, accountId => api.derive.council.votes().pipe(map(votes => (votes.find(_ref => {
    let [from] = _ref;
    return from.eq(accountId);
  }) || [null, {
    stake: api.registry.createType('Balance'),
    votes: []
  }])[1])));
}